import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function ContactNameForm({ aggregatorContactName, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Contact person:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="contactName"
          id="contactName"
          placeholder="Full name"
          value={aggregatorContactName || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(ContactNameForm);
